<template>
  <div>
    <HeaderDesktop v-if="!mobile" :header="info" :route="route" />
    <HeaderMobile v-if="mobile" :info="info" />
  </div>
</template>

<script>
import HeaderDesktop from "@/components/HeaderDesktop";
import HeaderMobile from "@/components/HeaderMobile";

export default {
  name: "Header",
  props: {
    info: Object,
    mobile: Boolean,
    route: String
  },
  components: {
    HeaderDesktop,
    HeaderMobile
  }
};
</script>
